import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { GapApi } from '../../../environments/api-urls';
import { getApiErrorMessages } from '../../shared/util/api-errors';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  private readonly sizeForPage = 1000;

  formatInputDateTime(date?: Date): string | undefined {
    if (!date) {
      return undefined;
    }

    const pad = (value: number) => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }

  /**
   * Where an API is called, as the environment lists it: APIM's route on the deployed environments, the microservice
   * running locally with `npm run start:local`. Paths then start at the version: `/v1/clients`.
   */
  getApiUrl(api: GapApi): string {
    return environment.apiUrls[api];
  }

  getSizeForPage(): number {
    return this.sizeForPage;
  }

  formatToCentral(date: Date): string {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(date);

    const map: Record<string, string> = {};
    for (const p of parts) {
      map[p.type] = p.value;
    }
    return `${map['year']}-${map['month']}-${map['day']} ${map['hour']}:${map['minute']}:${map['second']}`;
  }

  buildQueryParams(params: Record<string, any>): string {
    const qp = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null)
      .map(([key, value]) => {
        if (value instanceof Date) {
          return `${key}=${encodeURIComponent(this.formatToCentral(value))}`;
        }
        return `${key}=${encodeURIComponent(value)}`;
      });

    return qp.length ? `?${qp.join('&')}` : '';
  }

  getErrorMessage(error: any, defaultMessage: string): string {
    // GAINS Connect answers { Reason }, or { Reasons: [...] } when a request fails more than one validation
    const messages = getApiErrorMessages(error);
    if (messages.length) {
      return messages.join(' ');
    }

    if (error?.error?.Description) {
      return error.error.Description;
    }

    if (typeof error === 'string') {
      return error;
    }
    return defaultMessage;
  }
}
